<p-drawer
  [visible]="display"
  position="right"
  appendTo="body"
  header="Contact Information"
  (onHide)="onHide()"
  [style]="{ width: '30rem' }">
  <div class="vendorDetails-section mb-4">
    <p-scrollPanel [style]="{ height: 'auto;' }">
      <div class="scroll-box-hgt-drawer">
        <li
          class="d-flex align-items-center justify-content-between p-2 gap-4 mb-1"
          *ngFor="let item of vendorContacts">
          <div>
            <span class="mb-1" *ngIf="item.purposeD365 === 'Business'">
              Vendor Representative
            </span>
            <span class="mb-0" *ngIf="item.otherSpecification === 'Inside'">
              Inside Representative
            </span>
            <span class="mb-0" *ngIf="item.otherSpecification === 'Website'">
              Website
            </span>
            <span class="d-flex align-items-center mb-1">
              <span class="title me-1" (click)="openEditContact(item)"
                >Name:</span
              >
              <span class="text me-1 name" (click)="openEditContact(item)">{{
                item.nameD365
              }}</span>
              <span
                class="badge bg-primary name"
                *ngIf="item.purposeD365 === 'Business'"
                >Primary</span
              >
            </span>
          </div>
          <div class="col">
            <div class="text d-flex align-items-center">
              <a
                class="email d-flex gap-2 text-decoration-none align-items-center"
                [href]="item.emailLink"
                ><i class="icon-Email me-1"></i> {{ item.email }}</a
              >
            </div>
            <div class="text d-flex align-items-center">
              <a
                class="email d-flex gap-2 text-decoration-none align-items-center"
                [href]="item.phoneLink"
                ><i class="icon-Call me-1"></i> {{ item.phone }}</a
              >
            </div>
          </div>
        </li>
      </div>
    </p-scrollPanel>
  </div>
</p-drawer>
